// extracted by mini-css-extract-plugin
module.exports = {"board":"MainLayout_board__3erlq","leftTools":"MainLayout_leftTools__2uxWR"};